// extracted by mini-css-extract-plugin
export default {"title":"kkveoaVDhI_8fmzjeIyd","error":"WsV3zPBeshqyya6c2pAr","notification":"e4hsfeJLS227gcKG8LKf","dialog":"CqlCFnhS3RFPOGZJqXix"};